module.exports = __webpack_public_path__ + "img/btn_teachers_day@2x.a2cb30ba.png";